import actions from './actions'
import { UserState, UserAction } from './types'

const initialState: UserState = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  authorized: (import.meta.env.VITE_AUTHENTICATED as any) || false, // false is default value
  loading: false,
  loginProcessing: false,
  workspace: null,
  step: 0,
  serverType: '',
  unreadCnt: 0,
  entryError: null,
}

export default function userReducer(
  state: UserState = initialState,
  action: UserAction,
): UserState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_ENTRY_ERROR:
      return { ...state, entryError: action.payload }
    case actions.CLEAR_ENTRY_ERROR:
      return { ...state, entryError: null }
    default:
      return state
  }
}
